// Fonction pour obtenir la valeur d'un cookie
global.getCookie = function(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(key + '=')) {
            return decodeURIComponent(cookie.substring(key.length + 1));
        }
    }
    return null;
}

// Fonction pour définir la valeur d'un cookie
global.setCookie = function(key, value, expirationDays) {
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    var cookieString = encodeURIComponent(key) + '=' + encodeURIComponent(value);
    if (expirationDays !== null) {
        cookieString += ';path=/;expires=' + expirationDate.toUTCString();
    }
    document.cookie = cookieString;
}

// Fonction pour supprimer un cookie
global.deleteCookie = function(key) {
    document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
}

// Fonction pour effacer tous les cookies
global.clearCookies = function() {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        var cookieName = cookie.split('=')[0];
        deleteCookie(cookieName);
    }
}

// Fonction pour obtenir une valeur du local storage
global.getLocalStorage = function(key) {
    return localStorage.getItem(key);
}

// Fonction pour définir une valeur dans le local storage
global.setLocalStorage = function(key, value) {
    if (!value) removeLocalStorage(key);
    else localStorage.setItem(key, value);
}

// Fonction pour supprimer un élément du local storage
global.removeLocalStorage = function(key) {
    localStorage.removeItem(key);
}

// Fonction pour effacer tous les éléments du local storage
global.clearLocalStorage = function() {
    localStorage.clear();
}
